SEEK Pass identity information for the candidate.
